import styled from "styled-components";

export const TableContainer = styled.div`
  .empty-table {
    min-width: 0 !important;
    padding: 0;
    padding-top: 65px;
  }
`
